import type { BaseFilterParams } from "./api";
import type { Client } from "./client";

export enum UserRole {
  ADMIN = "admin",
  USER = "user",
}

export enum UserStatus {
  ACTIVE = "active",
  DEACTIVATED = "deactiavted",
}

export enum ClientUserPermission {
  READ = "read",
  WRITE = "write",
  FULL = "full",
}

export interface User {
  id: string;
  name: string;
  email: string;
  status: UserStatus;
  role: UserRole;
  client: Client;
  clientPermission?: ClientUserPermission;
}

export interface UserQueryParams extends BaseFilterParams {
  clientId?: string;
}

export interface BulkCreateUsersPayload {
  users: {
    name: string;
    email: string;
    clientId: number;
    clientPermission?: ClientUserPermission;
  }[];
}
